export const EmailIsValid = (email: string): boolean => {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
};

export const VersionIsValid = (version: string): boolean => {
  return /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/.test(
    version
  );
};

export const isReservedAppName = (appName: string): boolean => {
  return [
    'vehicle',
    'user',
    'facility',
    'property',
    'vendor',
    'seller',
    'client',
    'device',
    'partner',
  ].includes(appName.toLowerCase());
};
